/* 9-for-9 tripwire page (tw-*): checkout wiring, sticky CTA bar, testimonial
   wall. The ?angle= headline switch runs inline in the hero (before paint).
   Offer config comes from the hero section's <script id="tw-config">. */
(function () {
  'use strict';

  var cfg = { checkout_url: '', cart_variant: '' };
  try {
    var el = document.getElementById('tw-config');
    if (el) { var p = JSON.parse(el.textContent); cfg.checkout_url = p.checkout_url || ''; cfg.cart_variant = p.cart_variant || ''; }
  } catch (e) { /* keep defaults */ }

  /* ---------- CTAs ----------
     cart mode: every [data-tw-cta] submits the hero's plain POST /cart/add form.
     link mode: inheriting links get the hero's checkout URL. */
  if (cfg.cart_variant) {
    var form = document.getElementById('tw-cart-form');
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-tw-cta][data-tw-checkout="inherit"]');
      if (!a || !form) return;
      e.preventDefault();
      form.submit();
    });
  } else if (cfg.checkout_url) {
    document.querySelectorAll('[data-tw-checkout="inherit"]').forEach(function (a) { a.setAttribute('href', cfg.checkout_url); });
  }

  /* ---------- sticky CTA bar: slides in once past the hero ---------- */
  var bar = document.querySelector('[data-tw-sticky]');
  if (bar) {
    var threshold = parseInt(bar.getAttribute('data-tw-sticky'), 10) || 700;
    var shown = false;
    var onScroll = function () {
      var past = window.scrollY > threshold;
      if (past !== shown) { shown = past; bar.classList.toggle('is-visible', past); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- testimonial wall ---------- */
  document.querySelectorAll('[data-tw-wall]').forEach(function (wall) {
    var source = Array.prototype.slice.call(wall.querySelectorAll('.tw-wcard'));
    if (!source.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SPEEDS = [34, 46, 28];
    var tracks = [], halves = [], off = [0, 0, 0], ncols = 0;
    var ramp = 0, hovering = false, visible = false, raf = 0, last = 0;

    var colsFor = function (w) { return w < 720 ? 1 : w < 1000 ? 2 : 3; };
    var build = function () {
      var n = colsFor(window.innerWidth);
      if (n === ncols) return;
      ncols = n; tracks = []; halves = []; off = [0, 0, 0];
      wall.textContent = '';
      for (var c = 0; c < n; c++) {
        var col = document.createElement('div'); col.className = 'tw-wall__col';
        var track = document.createElement('div'); track.className = 'tw-wall__track';
        var mine = source.filter(function (_, i) { return i % n === c; });
        mine.forEach(function (card) { track.appendChild(card.cloneNode(true)); });
        if (!reduced) mine.forEach(function (card) { var d = card.cloneNode(true); d.setAttribute('aria-hidden', 'true'); track.appendChild(d); });
        col.appendChild(track); wall.appendChild(col); tracks.push(track);
      }
      wall.classList.add('is-ready');
      if (reduced) wall.style.overflowY = 'auto';
    };

    var frame = function (now) {
      var dt = Math.min(64, now - last) / 1000; last = now;
      ramp += ((hovering ? 0 : 1) - ramp) * Math.min(1, dt * 3);
      tracks.forEach(function (t, i) {
        var half = halves[i] || (halves[i] = t.scrollHeight / 2);
        if (!half) return;
        off[i] = (off[i] + SPEEDS[i % 3] * ramp * dt) % half;
        t.style.transform = 'translateY(' + (-off[i]) + 'px)';
      });
      raf = visible ? requestAnimationFrame(frame) : 0;
    };
    var start = function () { if (!raf && !reduced && visible) { last = performance.now(); raf = requestAnimationFrame(frame); } };

    build();
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { var b = ncols; build(); if (ncols === b) halves = []; }, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { halves = []; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es.some(function (x) { return x.isIntersecting; }); if (visible) start(); }, { threshold: 0.05 }).observe(wall);
    } else { visible = true; start(); }
    wall.addEventListener('mouseenter', function () { hovering = true; });
    wall.addEventListener('mouseleave', function () { hovering = false; });
  });
})();
